module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

function isActive(name){ return _.result(obj.selected, 'order_by') === name ? 'is-active' : ''; };
function isCoachStats(){ return _.eq(obj.stats_type, 'coach'); };

__p+='\n\n<form class="player-pool-filtres">\n	<div class="search-box">\n		<div class="search-box-container">\n			<input 	type="search"\n			          name="filter_by_name"\n			          id="player-pool-search"\n			          value="'+
((__t=( selected['filter_by_name'] ))==null?'':_.escape(__t))+
'"\n			          placeholder="Search Players" />\n			<button class="icon player-pool-search-icon js-player-pool-search-icon">\n				<i class="icon ion-ios-search-strong"></i>\n			</button>\n		</div>\n		<div>\n			<input '+
((__t=( selected.is_asc_order ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n			type="checkbox"\n			name="is_asc_order"\n			id="player-pool-order">\n			<label for="player-pool-order" class="icon js-player-pool-sort-asc-desc"></label>\n		</div>\n	</div>\n	<div class="more-filters">\n		<div class="js-player-pool-more-filters-container player-pool-more-filters-container '+
((__t=( !is_visible_filters ? 'hidden': '' ))==null?'':_.escape(__t))+
'">\n			<div class="selects-box">\n				<select name="filter_by_price" id="player-pool-by-price">\n					';
 _.each(filter.by_price, function(filter, index){ 
__p+='\n					<option '+
((__t=( selected['filter_by_price'] === filter.key ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					value="'+
((__t=( filter.key ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( filter.value ))==null?'':_.escape(__t))+
'\n					</option>\n					';
 }) 
__p+='\n				</select>\n				<select name="filter_by_squad" id="player-pool-by-teams">\n					<option value="">All Teams</option>\n					';
 _.each(filter.squads, function(squad){ 
__p+='\n					<option '+
((__t=( Number(selected['filter_by_squad']) === Number(squad.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					value="'+
((__t=( squad.id ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( squad.name ))==null?'':_.escape(__t))+
'\n					</option>\n					';
 }) 
__p+='\n				</select>\n				<select name="filter_by_position" id="player-pool-by-positions" class="js-player-pool-by-positions">\n					<option value="">All positions</option>\n					';
 _.each(filter.positions, function(position){ 
__p+='\n					<option '+
((__t=( Number(selected['filter_by_position']) === Number(position.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					value="'+
((__t=( position.id ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( position.name ))==null?'':_.escape(__t))+
'\n					</option>\n					';
 }) 
__p+='\n				</select>\n			</div>\n			<div class="checkboxes-box">\n				<div>\n					<label for="player-pool-dpp-only">\n						<input '+
((__t=( selected.filter_dpp_only ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n						class="ios-switch"\n						type="checkbox"\n						name="filter_dpp_only"\n						id="player-pool-dpp-only">\n						<span class="checkbox"></span>\n					</label>\n					<label for="player-pool-dpp-only">Show Dual Position players only</label>\n				</div>\n				<div>\n					<label for="player-pool-available-only">\n						<input '+
((__t=( selected.filter_available_only ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n						type="checkbox"\n						class="ios-switch"\n						name="filter_available_only"\n						id="player-pool-available-only">\n						<span class="checkbox"></span>\n					</label>\n					<label for="player-pool-available-only">Show players with an Available Status only</label>\n				</div>\n				<div>\n					<label for="player-pool-favourites-only">\n						<input '+
((__t=( selected.filter_favourite_only ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n						type="checkbox"\n						class="ios-switch"\n						name="filter_favourite_only"\n						id="player-pool-favourites-only">\n						<span class="checkbox"></span>\n					</label>\n					<label for="player-pool-favourites-only">Show watch list</label>\n				</div>\n			</div>\n		</div>\n		<a class="js-player-pool-more-filters player-pool-more-filters-link '+
((__t=( is_visible_filters ? 'hidden': '' ))==null?'':_.escape(__t))+
'">\n			<span>More filters</span>\n			<i class="ion-chevron-down"></i>\n		</a>\n		<a class="js-player-pool-less-filters player-pool-more-filters-link '+
((__t=( !is_visible_filters ? 'hidden': '' ))==null?'':_.escape(__t))+
'">\n			<span>Less filters</span>\n			<i class="ion-chevron-up"></i>\n		</a>\n	</div>\n</form>\n<div class="trade-pool-stats-tabs">\n	<div class="buttons-box">\n		<a class="btn-trade-pool-stats btn-trade-pool-base js-btn-trade-pool-base '+
((__t=( stats_type === 'base' ? 'is-active' : '' ))==null?'':_.escape(__t))+
'">Basic Stats</a>\n		<a class="btn-trade-pool-stats btn-trade-pool-coach js-btn-trade-pool-coach '+
((__t=( stats_type === 'coach' ? 'is-active' : ''))==null?'':_.escape(__t))+
'">Coach Stats</a>\n	</div>\n	<div class="player-pool-more-filters-container">\n		<div class="selects-box">\n			';
 if(isCoachStats()){ 
__p+='\n				<select name="coach_stats_type" id="coach-stats-type">\n					';
 _.each(coach_stats_types, function(coach_stat){ 
__p+='\n						<option value="'+
((__t=( coach_stat.value ))==null?'':_.escape(__t))+
'"\n								'+
((__t=( _.eq(coach_stats_type, coach_stat.value) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n							'+
((__t=( coach_stat.name ))==null?'':_.escape(__t))+
'\n						</option>\n					';
 }) 
__p+='\n				</select>\n			';
 } 
__p+='\n		</div>\n	</div>\n</div>\n<div class="trade-player-pool-table-head-container">\n	';
 if(isCoachStats()){ 
__p+='\n		<div class="trade-player-pool-table-head coach-stats '+
((__t=( coach_stats_type ))==null?'':_.escape(__t))+
'">\n			<div class="column column-1 js-order-by pointer '+
((__t=( isActive('name') ))==null?'':_.escape(__t))+
'" data-order-by="name"><span>Player</span></div>\n			<div class="column"><span>Add<br>Player</span></div>\n			<div class="column column-2 js-order-by pointer '+
((__t=( isActive('cost') ))==null?'':_.escape(__t))+
'" data-order-by="cost"><span>Price</span></div>\n\n			';
 if(coach_stats_type === 'form'){ 
__p+='\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.games_played') ))==null?'':_.escape(__t))+
'" data-order-by="stats.games_played"><span>PLD</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points"><span>AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.points_3_rounds_prior') ))==null?'':_.escape(__t))+
'" data-order-by="stats.points_3_rounds_prior"><span>RD '+
((__t=( (last_round_id - 2) > 1 ? last_round_id - 2 : '-' ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.points_2_rounds_prior') ))==null?'':_.escape(__t))+
'" data-order-by="stats.points_2_rounds_prior"><span>RD '+
((__t=( (last_round_id - 1) > 2 ? last_round_id - 1 : '-' ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.points_last_round') ))==null?'':_.escape(__t))+
'" data-order-by="stats.points_last_round"><span>RD '+
((__t=( last_round_id ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.last_3_avg') ))==null?'':_.escape(__t))+
'" data-order-by="stats.last_3_avg"><span>L3 AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.last_3_proj_avg') ))==null?'':_.escape(__t))+
'" data-order-by="stats.last_3_proj_avg"><span>L3 PRJ<br>AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.last_3_avg_vs_proj') ))==null?'':_.escape(__t))+
'" data-order-by="stats.last_3_avg_vs_proj"><span>L3 AVG vs <br>L3 PRJ AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.last_3_avg_vs_season') ))==null?'':_.escape(__t))+
'" data-order-by="stats.last_3_avg_vs_season"><span>L3 AVG vs<br>AVG</span></div>\n			';
 } 
__p+='\n\n			';
 if(coach_stats_type === 'value_predictor'){ 
__p+='\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.games_played') ))==null?'':_.escape(__t))+
'" data-order-by="stats.games_played"><span>PLD</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points"><span>AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.last_3_avg') ))==null?'':_.escape(__t))+
'" data-order-by="stats.last_3_avg"><span>L3 AVG PTS<br>(L3 Avg $ change)</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.rd_tog') ))==null?'':_.escape(__t))+
'" data-order-by="stats.rd_tog"><span>Rd '+
((__t=( most_recent_round_id ))==null?'':_.escape(__t))+
'<br>Minutes</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.tog') ))==null?'':_.escape(__t))+
'" data-order-by="stats.tog"><span>Avg<br>Minutes</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.break_even_one_round_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.break_even_one_round_after_current"><span>Proj BE<br>Rd '+
((__t=( _.min([actual_round_id, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.proj_score_one_round_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.proj_score_one_round_after_current"><span>Proj Score<br>Rd '+
((__t=( _.min([actual_round_id, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.proj_price_change_next_round') ))==null?'':_.escape(__t))+
'" data-order-by="stats.proj_price_change_next_round"><span>Proj $<br>change<br>after Rd '+
((__t=( _.min([actual_round_id, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.break_even_two_rounds_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.break_even_two_rounds_after_current"><span>Proj BE<br>Rd '+
((__t=( _.min([actual_round_id + 1, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.proj_score_two_rounds_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.proj_score_two_rounds_after_current"><span>Proj Score<br>Rd '+
((__t=( _.min([actual_round_id + 1, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.proj_price_change_next_two_rounds') ))==null?'':_.escape(__t))+
'" data-order-by="stats.proj_price_change_next_two_rounds"><span>Proj $<br>change<br>after Rd '+
((__t=( _.min([actual_round_id + 1, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n			';
 } 
__p+='\n\n			';
 if(coach_stats_type === 'consistency'){ 
__p+='\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.games_played') ))==null?'':_.escape(__t))+
'" data-order-by="stats.games_played"><span>PLD</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points"><span>AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.last_3_avg') ))==null?'':_.escape(__t))+
'" data-order-by="stats.last_3_avg"><span>L3 AVG PTS</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.last_5_avg') ))==null?'':_.escape(__t))+
'" data-order-by="stats.last_5_avg"><span>L5 AVG PTS</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.consistency') ))==null?'':_.escape(__t))+
'" data-order-by="stats.consistency"><span>Consistency Rating</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.in_20_avg') ))==null?'':_.escape(__t))+
'" data-order-by="stats.in_20_avg"><span>Games<br>20 < Avg</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.out_20_avg') ))==null?'':_.escape(__t))+
'" data-order-by="stats.out_20_avg"><span>Games<br>20 > Avg</span></div>\n			';
 } 
__p+='\n\n			';
 if(coach_stats_type === 'opposition'){ 
__p+='\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points"><span>AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.opp_avg_one_round_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.opp_avg_one_round_after_current"><span>Rd '+
((__t=( _.min([actual_round_id, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'<br>Opp Avg</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.opp_avg_two_rounds_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.opp_avg_two_rounds_after_current"><span>Rd '+
((__t=( _.min([actual_round_id + 1, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'<br>Opp Avg</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.opp_avg_three_rounds_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.opp_avg_three_rounds_after_current"><span>Rd '+
((__t=( _.min([actual_round_id + 2, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'<br>Opp Avg</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.opp_avg_3_rounds') ))==null?'':_.escape(__t))+
'" data-order-by="stats.opp_avg_3_rounds"><span>Opp 3 Rd Avg</span></div>\n			';
 } 
__p+='\n\n			';
 if(coach_stats_type === 'venues'){ 
__p+='\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points"><span>AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.venue_avg_one_round_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.venue_avg_one_round_after_current"><span>Avg at Venue<br>Rd '+
((__t=( _.min([actual_round_id, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.venue_avg_two_rounds_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.venue_avg_two_rounds_after_current"><span>Avg at Venue<br>Rd '+
((__t=( _.min([actual_round_id + 1, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.venue_avg_three_rounds_after_current') ))==null?'':_.escape(__t))+
'" data-order-by="stats.venue_avg_three_rounds_after_current"><span>Avg at Venue<br>Rd '+
((__t=( _.min([actual_round_id + 2, parseInt(process.env.TOTAL_ROUNDS_SIZE)], 10) ))==null?'':_.escape(__t))+
'</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.venue_avg_3_rounds') ))==null?'':_.escape(__t))+
'" data-order-by="stats.venue_avg_3_rounds"><span>3 Rd Venue Avg</span></div>\n			';
 } 
__p+='\n\n			';
 if(coach_stats_type === 'coach_choice'){ 
__p+='\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.games_played') ))==null?'':_.escape(__t))+
'" data-order-by="stats.games_played"><span>PLD</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points"><span>AVG</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.total_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.total_points"><span>Total points</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.selections') ))==null?'':_.escape(__t))+
'" data-order-by="stats.selections"><span>Total # selections</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.selections_info.c') ))==null?'':_.escape(__t))+
'" data-order-by="stats.selections_info.c"><span>% as Captain</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.selections_info.vc') ))==null?'':_.escape(__t))+
'" data-order-by="stats.selections_info.vc"><span>% as VC</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.selections_info.res') ))==null?'':_.escape(__t))+
'" data-order-by="stats.selections_info.res"><span>% as an Emergency</span></div>\n				<div class="column js-order-by pointer '+
((__t=( isActive('stats.selections_info.bc') ))==null?'':_.escape(__t))+
'" data-order-by="stats.selections_info.bc"><span>% on the Bench</span></div>\n			';
 } 
__p+='\n		</div>\n	';
 } else { 
__p+='\n		<div class="trade-player-pool-table-head">\n			<div class="column column-1 js-order-by pointer '+
((__t=( isActive('name') ))==null?'':_.escape(__t))+
'" data-order-by="name"><span>Player</span></div>\n			<div class="column"><span>Add<br>Player</span></div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('cost') ))==null?'':_.escape(__t))+
'" data-order-by="cost">\n				<span>Price</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('cost_round_diff') ))==null?'':_.escape(__t))+
'" data-order-by="cost_round_diff">\n				<span>Price Change<br>Last Rd</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('stats.games_played') ))==null?'':_.escape(__t))+
'" data-order-by="stats.games_played">\n				<span>Rounds<br>played</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('stats.selections') ))==null?'':_.escape(__t))+
'" data-order-by="stats.selections">\n				<span>Total<br>Selections</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('stats.owned_by') ))==null?'':_.escape(__t))+
'" data-order-by="stats.owned_by">\n				<span>Selected<br>By %</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points">\n				<span>Average<br>Per RND</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('stats.last_3_avg') ))==null?'':_.escape(__t))+
'" data-order-by="stats.last_3_avg">\n				<span>Form<br>(L3 Avg)</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('stats.cost_divided_by_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.cost_divided_by_points">\n				<span>$/points</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('stats.points_last_round') ))==null?'':_.escape(__t))+
'" data-order-by="stats.points_last_round">\n				<span>Points<br>RND '+
((__t=( last_round_id ))==null?'':_.escape(__t))+
'</span>\n			</div>\n			<div class="column js-order-by pointer '+
((__t=( isActive('stats.total_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.total_points">\n				<span>Total<br>points</span>\n			</div>\n\n		</div>\n	';
 } 
__p+='\n</div>';
}
return __p;
};
